import { useState, useEffect } from "react";
import clsx from "clsx";
import { translate } from "../../translations";
import StatementResult from "./statement_result";
import {
  ObjectId,
  Statement,
  Stored,
  StudentOpinion,
  PopulatedVotingSession,
  PopulatePartyOpinion,
} from "../../types";
import APIclient from "../../api-client";

export default function StatementPage({
  votingSession,
  statement,
  answers,
  toggleHiddenComment,
}: {
  votingSession: PopulatedVotingSession;
  statement: Stored<Statement>;
  answers: Array<Stored<StudentOpinion>>;
  toggleHiddenComment: (id: ObjectId, hidden: boolean) => void;
}) {
  const [showResults, setShowResults] = useState(false);
  const [partyAnswers, setPartyAnswers] = useState<
    Array<Stored<PopulatePartyOpinion>>
  >([]);

  useEffect(() => {
    APIclient.sessions
      .partyOpinions(votingSession.code, statement._id)
      .then(setPartyAnswers);
  }, [statement]);

  return (
    <>
      <h1 className="voting-session__title">{statement.description}</h1>

      <button
        className={clsx("button", { "button--outline": !showResults })}
        aria-pressed={showResults}
        onClick={() => setShowResults((b) => !b)}
      >
        {translate("teacher.votingSession.statementPage.showResults")}
      </button>

      {showResults && (
        <StatementResult
          statement={statement}
          partyAnswers={partyAnswers}
          answers={answers}
          toggleHiddenComment={toggleHiddenComment}
          argumentsEnabled={votingSession.argumentsEnabled}
        />
      )}
    </>
  );
}
